import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NSIRCSearchOrderFilter from './NSIRCSearchOrderFilters';
import { getSearch, getFilters} from '../../common/services/selectors';

function NSIRCSearchFilter({ filters, search }) {
	return (
		<div>
			<h4 className="section--menu_toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				Filter results
				<span className="open-menu"><svg xmlns="http://www.w3.org/2000/svg" className="icon"><use xlinkHref="#icon-filter"></use></svg></span>
			</h4>
			<div className="" aria-labelledby="dropdownMenuLink">
				<NSIRCSearchOrderFilter search={search} filter={filters} />
			</div>
		</div>				
	);
}

NSIRCSearchFilter.propTypes = {
    filters: PropTypes.object,
    search: PropTypes.object,
};


const mapStateToProps = state => ({ search: getSearch(state), filters: getFilters(state)});

export default connect(mapStateToProps)(NSIRCSearchFilter);
